import React from 'react';
import { AutoLoginExternalForm, AutoLoginLayout } from '@isyc-react/auth/modules/pods/login/auto';
export const AutoLoginExternalScene = () => {
    return (React.createElement(AutoLoginLayout, null,
        React.createElement(AutoLoginExternalForm, null)));
};
